import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Language } from './Language';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-language-update',
  templateUrl: './language-update.component.html'
})
export class LanguageUpdateComponent extends BaseUpdateComponent<Language> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Name", Validators.required, 'required', 'LANGUAGE.NAME.VALIDATION.REQUIRED');
    this.addValidatorToFc("Name", Validators.maxLength(100), 'maxlength', 'LANGUAGE.NAME.VALIDATION.MAXLENGTH');

  }

}
